export enum PaymentCardType {
    Debit = 'debit',
    Credit = 'credit'
}
